import {
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { EditorService } from '../../services/editor.service';

@Component({
  selector: 'app-inline-block-buttons',
  templateUrl: './inline-block-buttons.component.html',
  styleUrl: './inline-block-buttons.component.scss',
  standalone: false,
})
export class InlineBlockButtonsComponent {
  /** Blok, którym manipulujemy */
  @Input({ required: true }) target!: HTMLElement;

  /** Wyemitujemy, że trzeba usunąć komponent (np. po mouseleave) */
  @Output() closed = new EventEmitter<void>();

  @Output() moved = new EventEmitter<{ element: HTMLElement; dir: string }>();

  @Output() removed = new EventEmitter<HTMLElement>();

  constructor(
    private dialog: MatDialog,
    private editorService: EditorService
  ) {}

  /* ─── api publiczne ─── */
  move(dir: 'up' | 'down' | 'left' | 'right'): void {
    const parent = this.target.parentElement;
    if (!parent) {
      return;
    }

    const prev = this.target.previousElementSibling as HTMLElement | null;
    const next = this.target.nextElementSibling as HTMLElement | null;

    if ((dir === 'up' || dir === 'left') && prev) {
      parent.insertBefore(this.target, prev);
    }
    if ((dir === 'down' || dir === 'right') && next) {
      parent.insertBefore(next, this.target);
    }

    this.moved.emit({ element: this.target, dir });
  }

  /* klik w puste miejsce zamyka narzędzie (opcjonalne) */
  @HostBinding('style.pointer-events') pe = 'auto';
  onBackgroundClick(): void {
    this.closed.emit();
  }

  @HostListener('click', ['$event'])
  forward(ev: MouseEvent) {
    if ((ev.target as HTMLElement).closest('.toolbar')) {
      return;
    }
    this.target.dispatchEvent(
      new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
    );
  }

  /** Otwiera modal z narzędziami */
  // openEditor(): void {
  //   this.editorService.clickButton = true;
  //   const dialogRef = this.dialog.open(BlockEditorModalComponent, {
  //     data: { element: this.target },
  //     width: '900px',
  //     maxHeight: '90vh',
  //     panelClass: 'block-editor-dialog',
  //   });

  //   dialogRef.afterClosed().subscribe(() => {
  //     this.editorService.clickButton = false;
  //   });
  // }

  // deleteBlock(): void {
  //   this.editorService.clickButton = true;
  //   const el = this.target;
  //   const parent = el.parentElement;

  //   if (parent) {
  //     parent.removeChild(el); // fizycznie wyrzuć z DOM
  //     this.removed.emit(el); // daj znać rodzicowi, jeśli potrzebuje
  //   }

  //   /* zamknij nakładkę z przyciskami */
  //   this.closed.emit();
  //   this.editorService.clickButton = false;
  // }
}
